export default __webpack_public_path__ + "2616a9406d019663cfa055fd451a4ea9.png";